import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { TextInput } from "../Inputs";
import { DaumPlaceInput, GooglePlaceInput, YandexPlaceInput } from "./components";
export const PlaceInput = forwardRef(({ onPlace, autocompleteProvider = "google", ...props }, ref) => {
    if (autocompleteProvider === "none") {
        return _jsx(TextInput, { ...props, ref: ref });
    }
    if (autocompleteProvider === "daum") {
        return _jsx(DaumPlaceInput, { onPlace: onPlace, ...props, ref: ref });
    }
    if (autocompleteProvider === "yandex") {
        return _jsx(YandexPlaceInput, { onPlace: onPlace, ...props, ref: ref });
    }
    return _jsx(GooglePlaceInput, { onPlace: onPlace, ...props, ref: ref });
});
//# sourceMappingURL=PlaceInput.js.map